import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import Select from 'react-select';
import {
  injectTopMakesToOptions,
  skipTopMakes,
} from 'shared/components/SearchPanel/transformOptions';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import { sortCollection } from 'shared/helpers/arrays';
import SelectTranslated from '../SelectTranslated/SelectTranslated';
import UpdatedSelect from '../../UpdatedSelect/UpdatedSelect';
import TransportPanelAddition from '../TransportPanelAddition/TransportPanelAddition';
import TransportNumericOptions from '../TransportNumericOptions/TransportNumericOptions';
import SpecialPanel from './SpecialPanel/SpecialPanel';
import s from './CommercialPanel.css';

class CommercialPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    collapsed: PropTypes.bool.isRequired,
    transportType: PropTypes.shape().isRequired,
    //
    intl: intlShape.isRequired,
  };

  setChildTransportType = type => {
    const {
      selectedActions: { set },
      formState: { transportChild, transport },
      formVocabulary: { childrenTransportTypes },
    } = this.props;

    if (type) {
      set.transportChild(type);
    } else if (transport) {
      set.transportChild(
        this.findSelectedRootType(transportChild, childrenTransportTypes[transport.slug]),
      );
    }
  };

  findSelectedRootType = (selected, arr) => {
    if (!selected || !selected.id || !arr) {
      return null;
    }

    const selectedType = arr.find(type => type.id === selected.id);
    if (!selectedType) {
      return null;
    }

    if (selectedType.parent) {
      return arr.find(type => type.id === parseFloat(selectedType.parent));
    }

    return selectedType;
  };

  render() {
    const {
      formVocabulary,
      collapsed,
      formState,
      formData,
      selectedActions,
      transportType,
      intl,
    } = this.props;

    const transportSlug = transportType ? transportType.slug : null;

    const { makes, childrenTransportTypes } = formVocabulary;
    const { models } = formData;
    const selectedSetActions = selectedActions.set;
    const toSort = injectTopMakesToOptions(makes, intl);

    sortCollection(models, 'title');

    const transportTypes = formState.transport
      ? childrenTransportTypes[formState.transport.slug]
      : [];
    const rootTypes = transportTypes ? transportTypes.filter(type => !type.parent) : [];
    const selectedRootType = this.findSelectedRootType(formState.transportChild, transportTypes);

    const isSubtypesExist = transportTypes && !!transportTypes.filter(type => type.parent).length;
    const childTypes =
      isSubtypesExist && selectedRootType && transportTypes
        ? transportTypes.filter(type => parseFloat(type.parent) === selectedRootType.id)
        : [];
    const selectedChildType =
      formState.transportChild &&
      selectedRootType &&
      formState.transportChild.id !== selectedRootType.id
        ? formState.transportChild
        : null;

    return (
      <div>
        <div className={s.mainform}>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={toSort}
              labelKey="title"
              valueKey="id"
              disabled={!makes || !makes.length}
              onChange={selectedSetActions.make}
              value={formState.make}
              filterOption={skipTopMakes}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <UpdatedSelect
              instanceId="model-ff"
              name="model"
              placeholder={intl.formatMessage({ id: 'Модель' })}
              labelKey="title"
              valueKey="id"
              disabled={!models || !models.length}
              options={models && models.map ? models : []}
              onChange={selectedSetActions.model}
              value={formState.model}
              matchPos="start"
            />
          </div>

          {isSubtypesExist ? (
            <div className={s.filterItem}>
              <div className={s.flexContainer}>
                <div className={s.left}>
                  <SelectTranslated
                    placeholder={intl.formatMessage({ id: 'Тип' })}
                    instanceId="gearbox-ff"
                    name="gearboxes"
                    labelKey="title"
                    valueKey="id"
                    options={rootTypes}
                    onChange={selectedSetActions.transportChild}
                    value={selectedRootType}
                    matchPos="start"
                  />
                </div>
                <div className={s.right}>
                  <SelectTranslated
                    placeholder={intl.formatMessage({ id: 'Подтип' })}
                    instanceId="type-ff"
                    name="drives"
                    labelKey="title"
                    valueKey="id"
                    disabled={!selectedRootType || !childTypes.length}
                    options={childTypes}
                    onChange={this.setChildTransportType}
                    value={selectedChildType}
                    matchPos="start"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={s.filterItem}>
              <SelectTranslated
                placeholder={intl.formatMessage({ id: 'Тип' })}
                instanceId="gearbox-ff"
                name="gearboxes"
                labelKey="title"
                valueKey="id"
                options={rootTypes}
                onChange={selectedSetActions.transportChild}
                value={selectedRootType}
                matchPos="start"
              />
            </div>
          )}

          <TransportNumericOptions selectedActions={selectedActions} formState={formState} />
          <SpecialPanel
            formVocabulary={formVocabulary}
            formState={formState}
            selectedActions={selectedActions}
            type={transportSlug}
          />
        </div>

        {!collapsed && (
          <div className={s.fullForm}>
            <TransportPanelAddition
              formVocabulary={formVocabulary}
              selectedActions={selectedActions}
              formState={formState}
            >
              {transportType.slug === 'spetstehnika' && (
                <div className={cx(s.mainform, s.fullWidth)}>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Об-м кузова от,' })}
                      value={formState.capacityBodyFrom || ''}
                      onChange={selectedSetActions.capacityBodyFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, куб. м' })}
                      value={formState.capacityBodyTo || ''}
                      onChange={selectedSetActions.capacityBodyTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Об-м ковша от,' })}
                      value={formState.capacityBucketFrom || ''}
                      onChange={selectedSetActions.capacityBucketFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, куб. м' })}
                      value={formState.capacityBucketTo || ''}
                      onChange={selectedSetActions.capacityBucketTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Ш-на укладки от,' })}
                      value={formState.layingWidthFrom || ''}
                      onChange={selectedSetActions.layingWidthFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, м' })}
                      value={formState.layingWidthTo || ''}
                      onChange={selectedSetActions.layingWidthTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'В-та подъема от,' })}
                      value={formState.liftHeightFrom || ''}
                      onChange={selectedSetActions.liftHeightFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, м' })}
                      value={formState.liftHeightTo || ''}
                      onChange={selectedSetActions.liftHeightTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'В-та подачи от,' })}
                      value={formState.admissionHeightFrom || ''}
                      onChange={selectedSetActions.admissionHeightFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, м' })}
                      value={formState.admissionHeightTo || ''}
                      onChange={selectedSetActions.admissionHeightTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Вылет стр. от,' })}
                      value={formState.armBoomFrom || ''}
                      onChange={selectedSetActions.armBoomFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, м' })}
                      value={formState.armBoomTo || ''}
                      onChange={selectedSetActions.armBoomTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Г-на копания от,' })}
                      value={formState.depBigFrom || ''}
                      onChange={selectedSetActions.depBigFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, м' })}
                      value={formState.depBigTo || ''}
                      onChange={selectedSetActions.depBigTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Нараб. от,' })}
                      value={formState.productivityFrom || ''}
                      onChange={selectedSetActions.productivityFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до, м/ч.' })}
                      value={formState.productivityTo || ''}
                      onChange={selectedSetActions.productivityTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                </div>
              )}
            </TransportPanelAddition>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(CommercialPanel));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/CommercialPanel/CommercialPanel.js